import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from 'app/resources/services/http.service';
import { LojaCarrinhoService } from 'app/resources/services/loja-carrinho.service';

@Injectable()
export class LojaService {

  public pedidoSelecionado;
  public processando = false;
  public departamentos: Array<any> = [];
  public produtos: Array<any> = [];
  public categorias: Array<any> = [];
  public categoriaSelecionada: any;

  constructor(
    private router: Router,
    private http: HttpService,
    private lojaCarrinho: LojaCarrinhoService) { }

  public goVitrine(parceiro) {
    this.processando = true;
    this.lojaCarrinho.parceiro = parceiro;
    this.categoriaSelecionada = undefined;
    this.departamentos = [];
    this.categorias = [];
    this.produtos = [];

    this.router.navigate(['/loja/vitrine']);

    this.http.pathRest().get('loja/parceiros/' + this.lojaCarrinho.parceiro.id + '/' +
      this.lojaCarrinho.parceiro.uuid + '/produtos/', true)
      .subscribe(
        sucesso => {
          this.produtos = sucesso.json();
          this.getCategorias();
        }, erro => {
          this.processando = false;
        });
  }

  public getCategorias() {
    this.http.pathRest().get('loja/parceiros/' + this.lojaCarrinho.parceiro.id + '/'
      + this.lojaCarrinho.parceiro.uuid + '/categorias/', true)
      .subscribe(
        sucesso => {
          this.departamentos = sucesso.json();
          this.processando = false;
        }, erro => {
          this.processando = false;
        });
  }

  public buscarPorTermo(termo) {
    this.processando = true;
    this.departamentos = [];
    this.categorias = [];
    this.produtos = [];

    this.http.pathRest().get('loja/parceiros/' + this.lojaCarrinho.parceiro.id + '/' +
      this.lojaCarrinho.parceiro.uuid + '/produtos/?nome=' + termo, true)
      .subscribe(
        sucesso => {
          this.produtos = sucesso.json();
          this.getCategorias();
        }, erro => {
          this.processando = false;
        });
  }

  public buscarPorTermoNaCategoriaSelecionada(termo) {
    this.processando = true;
    this.http.pathRest().get('loja/parceiros/' + this.lojaCarrinho.parceiro.id + '/' +
      this.lojaCarrinho.parceiro.uuid + '/produtos/?nome=' + termo + '&categoria=' +
      this.categoriaSelecionada.arvore, true)
      .subscribe(
        sucesso => {
          this.produtos = sucesso.json();
          this.processando = false;
        }, erro => {
          this.processando = false;
        });
  }

  public carregarSubCategorias(categoria) {
    // TODO Receber a arvore em vez de categoria

    this.processando = true;
    this.http.pathRest().get('loja/parceiros/' + this.lojaCarrinho.parceiro.id + '/' +
      this.lojaCarrinho.parceiro.uuid + '/categorias/' + categoria.arvore + '/produtos/', true)
      .subscribe(
        sucesso => {
          this.produtos = sucesso.json();
          this.categoriaSelecionada = categoria;

          this.http.pathRest().get('loja/parceiros/' + this.lojaCarrinho.parceiro.id + '/' +
            this.lojaCarrinho.parceiro.uuid + '/categorias/' + categoria.arvore + '/categorias/', true)
            .subscribe(
              data => {
                this.categorias = data.json();
                this.processando = false;
              }, erro => {
                this.processando = false;
              });
        }, erro => {
          this.processando = false;
        });
  }

  public clean() {
    this.pedidoSelecionado = undefined;
    this.processando = false;
    this.departamentos = [];
    this.produtos = [];
    this.categorias = [];
    this.categoriaSelecionada = undefined;
  }
}



// WEBPACK FOOTER //
// ./src/app/resources/services/loja.service.ts